const initialState = "";

export const navbarReducers = (state=initialState, action) => {
    switch(action.type){
        case 'sidebar_click':
        return(
            (!state)
        )

        default: return state
    }
}